import React, {useState} from "react";
import {supabase} from "../services/supabase";

function Contact (){
    const [form, setForm] = useState({
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        service: "",
        message: "",
    });

    const [success, setSuccess] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setSuccess(false);

        const { error } = await supabase.from("messages").insert([form]);

        setSubmitting(false);
        if (error) {
            alert("Failed to send message. Please try again.");
            console.error(error);
        } else {
            setForm({ first_name: "", last_name: "", email: "", phone: "", service: "", message: "" });
            setSuccess(true);

        }
    };
    return(
        <>
            <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">

                <div className="text-center mb-16">
                    <h1 className="text-4xl font-bold text-gray-900 mb-4">Get In Touch</h1>
                    <p className="text-xl text-gray-600 max-w-2xl mx-auto">We're here to help you with all your legal needs. Reach out to us and we'll respond as soon as possible.</p>
                </div>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">

                    <div className="bg-white rounded-xl shadow-lg p-8">
                        <h2 className="text-2xl font-bold text-gray-900 mb-8">Contact Information</h2>

                        <div className="flex items-start mb-6">
                            <div
                                className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center">
                                <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor"
                                     viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                </svg>
                            </div>
                            <div className="ml-4">
                                <h3 className="text-lg font-semibold text-gray-900">Address</h3>
                                <p className="text-gray-600 mt-1">
                                    Tiloi Plaza, 2nd Floor
                                    <br/>
                                    Ronald Ngala Street
                                    <br/>
                                    P.O. Box 1860-30100
                                    <br/>
                                    Eldoret, Kenya
                                </p>
                            </div>
                        </div>
                        <div className="flex items-start mb-6">
                            <div
                                className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center">
                                <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor"
                                     viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path>
                                </svg>
                            </div>
                            <div className="ml-4">
                                <h3 className="text-lg font-semibold text-gray-900">Phone</h3>
                                <p className="text-gray-600 mt-1"><a href="tel:070101010101"
                                                                     className="hover:text-blue-600 transition-colors">+254 737 870943</a>
                                </p>
                            </div>
                        </div>
                        <div className="flex items-start mb-8">
                            <div
                                className="flex-shrink-0 w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center">
                                <svg className="w-5 h-5 text-purple-600" fill="none" stroke="currentColor"
                                     viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                                          d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
                                </svg>
                            </div>
                            <div className="ml-4">
                                <h3 className="text-lg font-semibold text-gray-900">Email</h3>
                                <p className="text-gray-600 mt-1"><a href="mailto:legalaid@gmail.com"
                                                                     className="hover:text-blue-600 transition-colors">childcarelegalaid@gmail.com</a>
                                </p>
                            </div>
                        </div>

                        <div className="bg-gray-50 rounded-lg p-6">
                            <h3 className="text-lg font-semibold text-gray-900 mb-3">Office Hours</h3>
                            <div className="space-y-2 text-gray-600">
                                <div className="flex justify-between">
                                    <span>Monday - Friday</span>
                                    <span>8:00 AM - 6:00 PM</span>
                                </div>
                                <div className="flex justify-between">
                                    <span>Saturday</span>
                                    <span>Closed</span>
                                </div>
                                <div className="flex justify-between">
                                    <span>Sunday</span>
                                    <span>Closed</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="bg-white rounded-xl shadow-lg p-8">
                        <h2 className="text-2xl font-bold text-gray-900 mb-8">Send Us a Message</h2>
                        <form className="space-y-6" onSubmit={handleSubmit}>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">First Name</label>
                                    <input
                                        type="text"
                                        name="first_name"
                                        value={form.first_name}
                                        onChange={handleChange}
                                        className="form-input w-full px-4 py-3 border border-gray-300 rounded-lg"
                                        placeholder="John"
                                        required
                                    />
                                </div>
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-2">Last Name</label>
                                    <input
                                        type="text"
                                        name="last_name"
                                        value={form.last_name}
                                        onChange={handleChange}
                                        className="form-input w-full px-4 py-3 border border-gray-300 rounded-lg"
                                        placeholder="Doe"
                                        required
                                    />
                                </div>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Email</label>
                                <input
                                    type="email"
                                    name="email"
                                    value={form.email}
                                    onChange={handleChange}
                                    className="form-input w-full px-4 py-3 border border-gray-300 rounded-lg"
                                    placeholder="john@example.com"
                                    required
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Phone</label>
                                <input
                                    type="tel"
                                    name="phone"
                                    value={form.phone}
                                    onChange={handleChange}
                                    className="form-input w-full px-4 py-3 border border-gray-300 rounded-lg"
                                    placeholder="0701010101"
                                    required
                                />
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Legal Service
                                    Needed</label>
                                <select
                                    name="service"
                                    value={form.service}
                                    onChange={handleChange}
                                    className="form-select w-full px-4 py-3 border border-gray-300 rounded-lg"
                                    required
                                >
                                    <option value="">Select a service</option>
                                    <option value="childprotection">Child Protection</option>
                                    <option value="childdefilement">Child Defilement</option>
                                    <option value="inheritance">Family Probate& Administration</option>
                                    <option value="humanrights">Human Rights Violation</option>
                                    <option value="civilcases">Civil Cases</option>
                                    <option value="injustice & corruption">Injustice & Corruption</option>
                                    <option value="other">Other</option>
                                </select>
                            </div>

                            <div>
                                <label className="block text-sm font-medium text-gray-700 mb-2">Message</label>
                                <textarea
                                    rows="5"
                                    name="message"
                                    value={form.message}
                                    onChange={handleChange}
                                    className="form-textarea w-full px-4 py-3 border border-gray-300 rounded-lg"
                                    placeholder="Please describe your legal matter..."
                                    required
                                ></textarea>
                            </div>

                            <button
                                type="submit"
                                disabled={submitting}
                                className="w-full bg-orange-900 text-white py-3 px-6 rounded-lg font-semibold hover:bg-orange-700"
                            >
                                {submitting ? "Sending..." : "Send Message"}
                            </button>
                        </form>

                        {success && (
                            <div className="mt-6 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
                                <div className="flex items-center">
                                    <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                        <path
                                            fillRule="evenodd"
                                            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                            clipRule="evenodd"
                                        ></path>
                                    </svg>
                                    Thank you for your message! We'll get back to you soon.
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <div className="mt-16">
                    <div className="bg-white rounded-xl shadow-lg overflow-hidden">
                        <div className="p-6">
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">Find Us</h2>
                            <p className="text-gray-600 mb-6">Located in the heart of Eldoret, we're easily accessible
                                and ready to serve you.</p>
                        </div>
                        <div className="h-96 bg-gray-200">
                            <iframe
                                title="Tiloi Plaza Map"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1993.6018056180474!2d35.27873887705433!3d0.5185902218227331!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182aa52a1f3a971d%3A0x81dbb79f09ea227b!2sTiloi%20Plaza!5e0!3m2!1sen!2ske!4v1720123456789!5m2!1sen!2ske"
                                width="100%"
                                height="100%"
                                className="border-0 w-full h-full"
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            ></iframe>
                        </div>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Contact;